// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2ES0K","footer":"ModalCreateQualiphyProcedure_footer__B8EhS","additionData":"ModalCreateQualiphyProcedure_additionData__2y96i"};